import { SuperAdminConstants } from '../../../_constants';

const initialState = { combinedMetricDenyLoading: true, data: '', error: false };

export function combinedMetricDenyReducer(state = initialState, action) {
    
    switch (action.type) {
        case SuperAdminConstants.REQUEST_COMBINED_DENY_METRIC:
            return {
                combinedMetricDenyLoading: true,
                data: '',
                error: false
            };
        case SuperAdminConstants.RECEIVE_COMBINED_DENY_METRIC:
            return {
                combinedMetricDenyLoading: false,
                data: action,
                error: false
            };
        case SuperAdminConstants.COMBINED_DENY_METRIC_ERROR:
            return {
                combinedMetricDenyLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/SuperAdmin/DefineMetric/combinedMetricDeny.reducer.js